<div class="flex h-screen flex-row">
  <!-- Desktop Sidebar -->
  <!-- h-screen: sem altura no pai, o `h-full` da aside não resolve, ela cresce com o
       menu e o rodapé (versão) some abaixo da dobra. -->
  <div class="hidden h-screen pt-[72px] md:block">
    <app-sidebar />
  </div>

  <!-- Mobile Sidebar -->
  <app-mobile-sidebar />

  <div class="bg-card flex grow flex-col content-start overflow-hidden">
    <app-navbar />
    <div
      class="scrollbar-thumb-rounded scrollbar-track-rounded mt-[72px] flex grow flex-col overflow-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-muted"
      id="main-content">
      <!-- Largura máxima padronizada para todas as telas (centralizada em um único lugar) -->
      <div class="mx-auto flex w-full max-w-[1536px] grow flex-col">
        <router-outlet />
      </div>
      <ngx-sonner-toaster richColors />
    </div>
  </div>

  <app-modal-tenant-logado />
  <app-modal-trocar-senha />
  <app-novidades-versao />
  <app-aviso-convites />
</div>
